import Views from "@/views";
import Layout from "@/components/Layouts/Index.vue";

/* Views */
const { PreschoolDimensionsView, PreschoolTeacherAssigmentView, PreschoolTeacherAssigmentEdit, PreschoolMyGroupsContent, PreschoolScoresContent, PreschoolDimensionEdit } = Views;

const preschoolRouter = {
  path: "/preschool",
  component: Layout,
  redirect: "dashboard",
  name: "Preschool",
  history: false,
  meta: {
    requiresAuth: true,
  },
  children: [
    {
      path: "dimensions",
      name: "PreschoolDimensions",
      component: PreschoolDimensionsView,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "teacher-assigment",
      name: "TeacherAssigment",
      component: PreschoolTeacherAssigmentView,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "academic-assignments-edit/:Id?",
      name: "TeacherAssigmentEdit",
      component: PreschoolTeacherAssigmentEdit,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "preschool-mygroups",
      name: "PreschoolMyGroups",
      component: PreschoolMyGroupsContent,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "preschool-score-edit/:Id?",
      name: "PreschoolScoreEdit",
      component: PreschoolScoresContent,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "preschool-dimension-edit/:Id?",
      name: "PreschoolDimensionEdit",
      component: PreschoolDimensionEdit,
      meta: {
        requiresAuth: true,
      },
    },
  ],
};

export default preschoolRouter;
